import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";
import { AppContext } from "../../../../Context/AppContext";
import AppSettings from "../../../../Settings/AppSettings";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ReactHtmlParser from "react-html-parser";

const LongDescription = ({ productID, productDescriptionAvailable, longDescription, setLongDescription, setInitialDescriptionAndImages }) => {
  const { setLongDescriptionGlobal } = useContext(AppContext);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [editPage, setEditPage] = useState(false);
  useEffect(() => setLoading({
      status: "",
      message: "",
  }), [longDescription])
  useEffect(() => {
    if (productID !== "0" && productDescriptionAvailable) {
      load_Long_Description(productID);
    }
  }, [productID]);

  async function load_Long_Description(productID) {
    setLoading({
      status: "Loading",
      message: "Loading Long Description",
    });
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}product/${productID}/description/get`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      setLongDescription(ret.data.data);
      setInitialDescriptionAndImages((prev) =>{
        return  {...prev, description: ret.data.data}
      })
      setLoading({
        status: "Success",
        message: undefined,
      });
    } else {
      setLoading({
        status: "Error",
        message: "Error while Loading Long Description",
      });
    }
  }

  async function handleChange(value) {
    setLongDescription(value);
  }

  async function on_save() {
    if (productID === "0") {
      setLongDescriptionGlobal(longDescription);
      setEditPage(false);
      setLoading({
        status: "Success",
        message: "",
      });
      return;
    }
    setLoading({
      status: "Saving",
      message: "Saving changes",
    });

    let res = await ServiceWrapper.doPost(
      `${api_base_url}product/${productID}/description/save`,
      {
        description: longDescription,
        isRichText: true,
      },
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setInitialDescriptionAndImages((prev) =>{
          return  {...prev, description: longDescription}
        })
        setLoading({
          status: "Success",
          message: res.data.message,
        });
        setEditPage(false);
      } else {
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      setLoading({
        status: "Error",
        message: "Error while saving, Please try after some time.",
      });
    }
  }

  return (
    <div className="tw-rounded tw-w-[890px] tw-ms-2.5 tw-border tw-shadow-[1px_2px_16px_0px_rgba(23,43,77,0.08)] tw-border-solid tw-border-[#EBECF0]">
        <div className="py-3 px-3 tw-flex tw-justify-between">
          <label className="tw-text-base tw-font-semibold">Long Description</label>
          {!editPage ? (
            <button
              type="button"
              className="button-style"
              onClick={() => {
                setEditPage(true);
              }}>
              Edit
            </button>
          ) : (
            <div className="d-flex tw-items-center tw-gap-3">
              <button
                type="button"
                className="outline-button"
                onClick={() => setEditPage(false)}
              >
                Cancel
              </button>
              
              
              <button
                type="button"
                className="button-style"
                onClick={on_save}
              >
                Save
              </button>
            </div>
          )}
        </div>
        <div className="card-body text-dark" style={{ minHeight: "200px" }}>
          {Loading.status !== "Loading" && (
            <>
              {editPage ? (
                <ReactQuill
                  theme="snow"
                  value={longDescription}
                  onChange={handleChange}
                />
              ) : (
                <div>
                  {longDescription ? (
                    ReactHtmlParser(longDescription)
                  ) : (
                    <label className="tw-text-[#97A0AF] tw-text-sm tw-font-medium">Long description is empty</label>
                  )}
                </div>
              )}
            </>
          )}
          <LoadingSuccessErrorAlert loading={Loading} />
        </div>
      </div>
  );
};
export default LongDescription;
